module.exports = __webpack_public_path__ + "static/media/4_uhr_lathundar.92dacd7e.jpg";